import { Modal } from 'bootstrap';

let mefaExternalLinkModal = new Modal(document.getElementById('external-link-modal'));

export default function initExternalLink(){

	var links = document.querySelectorAll('a');
    for(var i = 0; i < links.length; i++) {
		var link = links[i];
		var linkTarget = link.getAttribute("href");
		if(linkTarget != null){
			if(isExternalLink(linkTarget)){
				if(!checkForExternalModal(link, linkTarget)){
					if((isExternalLink(linkTarget) || linkTarget.includes(".pdf") || linkTarget.includes(".zip")) && link.classList.contains("ab-item") === false && link.classList.contains("external-link-ok") === false){
						link.setAttribute("target", "_blank");
						link.classList.add("external-link-ok");
						link.innerHTML += '<span class="visually-hidden"> - open in new window</span>';

						if (link.closest('.contact-item')) {
							const contactItem = link.closest('.contact-item');
							contactItem.dataset.link = linkTarget;
							contactItem.addEventListener('click', (e) => {
								e.preventDefault();
								window.open(e.currentTarget.dataset.link, '_blank');
							});
						}
					}
				}
			}
		}
    }
};

var checkForExternalModal = (link, linkTarget) => {
	let found = false;
	window.externalLinkDomains.forEach(domain => {
		if (linkTarget.includes(domain)) {
			found = true;
			link.classList.add("external-link-modal");
			link.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				let container = document.getElementById('external-link-modal');
				if(container){
					container.classList.remove("visually-hidden");
					document.querySelectorAll('.external-content-container').forEach(el => {
						el.classList.add("visually-hidden");
					});
					let external_content = document.querySelector(`.external-content-container[data-domain="${domain}"]`);
					external_content.classList.remove("visually-hidden");
					external_content.style.removeProperty('display');
					let continueLink = external_content.querySelector('.continue');
					if(continueLink){
						continueLink.setAttribute("href", linkTarget);
						continueLink.setAttribute("target", "_blank");
						if(!continueLink.classList.contains("processed")){
							continueLink.addEventListener('click', (e) => {
								continueLink.classList.add("processed");
								mefaExternalLinkModal.hide();
							});
						}
					}
				}
				mefaExternalLinkModal.show();
			})
		}
	});

	return found;
}

var isExternalLink = function(url) {
	try{
		var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
		if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
		if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
		return false;
	}catch(e){
		return false;
	}
}
